import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { drawerContentWidth, drawerControlsWidth } from 'components/InCall/InCallDrawerHolder';

/* Footer Breakpoints
 * compact: (280px -> 660px) left: none; center: audio, video, hand, end, more; right: none
 * dense: (660px -> 780px) left: 1 pip; center: layout, audio, video, present, record, hand, captions; right: end, more
 * full: (780px -> 860px) left: 1 pip; center: layout, audio, video, present, record, hand, captions; right: duration, end, more
 * max: (860px +) left: 1 or 2 pips; center: layout, audio, video, present, record, hand, captions; right: duration, end, more
 */

export default function useViewport() {
  const isDrawerOpen = !!useSelector((state: any) => state?.app?.inCallDrawer?.subComponentType);
  const drawerWidth = isDrawerOpen ? drawerContentWidth + drawerControlsWidth : drawerControlsWidth;
  const isFooterCompact = useMediaQuery(`(max-width:${660 + drawerWidth}px)`);
  const isFooterDense = useMediaQuery(`(min-width:${660 + drawerWidth}px)`);
  const isFooterFull = useMediaQuery(`(min-width:${780 + drawerWidth}px)`);
  const isFooterMax = useMediaQuery(`(min-width:${860 + drawerWidth}px)`);
  const isPortrait = useMediaQuery(`(orientation: portrait)`);
  const isMobileHeight = useMediaQuery('(max-height:600px)');
  const isMobileView = isFooterCompact || isMobileHeight; // no layout switch && mobile layout from sdk

  return {
    isFooterCompact,
    isFooterDense,
    isFooterFull,
    isFooterMax,
    isMobileView,
    isPortrait
  };
}
